<template>
  <v-container grid-list-md class="rss-card-container" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
      <v-card :id=newsSource :class="['card rss-card item ma-2', className]" :elevation="2">
          <v-img v-if="displayThumb == 'true'"
            class="card-thumb"
            contain
            :src="rssImage"
          />
          <v-card-title>
            {{ displayTitle }}
          </v-card-title>
          <v-card-text>
            <v-flex text-xs-left
              style="cursor: pointer"
              v-for="(item, idx) in articles"
              :key="idx"
            >
            <a :href="decodeUrl(item.link)" target="_blank" rel="noopener noreferrer">
              <div class="card-title" v-html="item.title"></div>
            </a>
            <div class="card-description" v-html="truncateText(item.description, 100, '...')"></div>
            </v-flex>
          </v-card-text>
      </v-card>
   </v-container>
</template>

<script>
import rssApi from '../services/RssService'
import lozad from 'lozad'

export default {
  name: 'RssCard',
  props: [
      'newsSource',
      'displayTitle',
      'displayThumb',
      'className',
      'rssImage'
      ],
  data () {
    return {
      articles: [],
      show: false,
      loading: false,
      noData: false
    }
  },
  methods: {
    fetchNewsData () {
      rssApi.fetchCollection(this.newsSource)
        .then(response => {
          // eslint-disable-next-line no-console
          console.log(response)
          // eslint-disable-next-line no-console
          console.log('RSS TEST')
          if (Object.keys(response).length) {
            this.articles = response.items
            this.loading = false
            this.noData = false
          } else {
            this.noData = true
            this.loading = false
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    },
    loadImages () {
      const observer = lozad('.lozad', {
          rootMargin: '100px 0px', // like css margin
          // threshold: 0.1 // ratio of element convergence
          loaded: function(el) {
              // Custom implementation on a loaded element
              el.classList.add('loaded');
              // el.classList.remove('loading-blur');
          }
      });

      observer.observe();
    },
    truncateText (text, length, suffix) {
        if (text.length == 0) {
          return text
        }
        else {
          var div = document.createElement("div");
          div.innerHTML = text;
          var strippedText = div.textContent || div.innerText || "";

          return strippedText.substring(0, length) + suffix
        }
    },
    decodeUrl (url) {
      var div = document.createElement('div');
      div.innerHTML = url
      var decoded = div.firstChild.nodeValue

      return decoded
    }
  },
  mounted () {
    this.fetchNewsData(),
    this.loadImages()
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 6
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  },
  filters: {
    strippedContent: function(string) {
      return string.replace(/<\/?[^>]+>/ig, " "); 
    }
  }
}
</script>

<style lang="scss" scoped>
.rss-card-container {
  height: 100%;

  .rss-card {
    height: 100%;
    /*
    max-height: 500px;
    overflow-y: scroll;
    */

    .v-card__title {
      padding-left: 16px;
      padding-bottom: 0;
    }

    .card-title {
      font-weight: 700;
      font-size: .75rem;
      line-height: .875rem;
    }
    .card-description {
      font-size: .75rem;
      line-height: .875rem;
    }
  }


  .card-with-image { 
    .card-thumb {
      height: 100px;
    }
  }

}
</style>

<style lang="scss">
  .rss-card-container {
    height: 100%;

  
    #rennlist {
        max-height: 520px;
        
        .card-thumb {
          background-color: #36576f;
          height: 75px;

          .v-image__image.v-image__image--contain {
            background-size: 80%;
          }
        }
        .v-card__text {
          max-height: 400px;
          overflow-y: scroll;
        }
    }

    #flatsixes {
        max-height: 520px;
        
        .card-thumb {
          height: 75px;

          .v-image__image.v-image__image--contain {
            background-size: 80%;
          }
        }

        .v-card__text {
          max-height: 400px;
          overflow-y: scroll;
        }
    }

    #porschenewsroom {
        max-height: 520px;

        .card-thumb {
          height: 75px;
        }

        .card-title {
          padding: 4px;
        }

        .v-card__text {
          max-height: 400px;
          overflow-y: scroll;

          .card-description {
            display: none
          }
        }
    }

    #marketwatch {
        max-height: 700px;

        .card-thumb {
          background-color: #2E2E2F;
          height: 50px;

          .v-image__image.v-image__image--contain {
            background-size: 65%;
            background-position: center center !important;
          }
        }
        
        .v-card__text {
          max-height: 620px;
          overflow-y: scroll;
        }
    }

    #kiplinger {
        max-height: 700px;
        
        .card-thumb {
          background-color: #cc2936;
          height: 50px;

          .v-image__image.v-image__image--contain {
            background-size: 80% 100%;
            background-position: center 4px !important;
          }
        }

        .v-card__text {
          max-height: 620px;
          overflow-y: scroll;
        }
    }

    #investopedia {
        max-height: 700px;

        .card-thumb {
            background-color: #eee;
            height: 50px;

            .v-responsive__content {
              background: url('../assets/images/investopedia.png');
              background-repeat: no-repeat;
              background-size: 80% 80%;
              background-position: center center;
            }
        }
        
        .v-card__text {
          max-height: 620px;
          overflow-y: scroll;
        }
    }
  }

</style>